import { useEffect, useRef, useState } from 'react';
import { Header, Table, Input } from 'react-frontier';
import { Link } from 'react-router-dom';
import { useBreadcrumbs } from '../Hooks';
import { UserClass } from '../SiteClasses';
import { formatUnix } from '../SiteUtil';
import API from '../API';

var Users = ()=>{
	var { setTitle } = useBreadcrumbs();
	var [loadError, setLoadError] = useState<string>(null);
	var [users, setUsers] = useState<UserClass[]>(null);
	var [filter, setFilter] = useState<string>('');
	var [searchUsers, setSearchUsers] = useState<UserClass[]>(null);
	var [searching, setSearching] = useState<boolean>(false);
	var searchTimeout = useRef<any>(null);

	useEffect(()=>{
		setTitle('Usuarios');
		API.getUsers().then(res=>{
			if(res.error) return setLoadError(res.message);
			setUsers(res.data);
		}).catch(()=>{
			setLoadError('Hubo un error cargando la lista de usuarios (LCL-1)');
		});
	}, []);

	var onSearchChange = (val: string)=>{
		setFilter(val);
		if(searchTimeout.current) clearTimeout(searchTimeout.current);
		if(val.trim().length<3) return setSearchUsers(null);
		searchTimeout.current = setTimeout(()=>search(val), 500);
	}

	var search = (query: string)=>{
		setSearching(true);
		setSearchUsers(null);
		API.searchUsers(query).then(res=>{
			if(res.error) return setLoadError(res.message);
			setSearchUsers(res.data);
		}).catch(()=>{
			setLoadError('Hubo un error al buscar el usuario. (SUS-1)');
		}).finally(()=>{
			setSearching(false);
		});
	}

	if(loadError) return <Header text='Error' subtext={loadError} />;
	if(!users) return <Header text='Cargando datos' loading />;

	var shown_users = searchUsers || users;

	return <div>
		<Table style={{ width: 800, margin: 'auto', marginTop: 20 }} striped>
			<Table.Head title='Usuarios'>
				<Table.Row>
					<Table.Cell colSpan={5} style={{ padding: 8 }}>
						<Input fluid placeholder='Buscar...' value={filter} onChange={onSearchChange} iconName='search' style={{ margin: 0 }} />
					</Table.Cell>
				</Table.Row>
				<Table.Row>
					<Table.Cell header collapsing>ID</Table.Cell>
					<Table.Cell header>Nombre</Table.Cell>
					<Table.Cell header>Apellido</Table.Cell>
					<Table.Cell header>Email</Table.Cell>
					<Table.Cell header collapsing>Creación</Table.Cell>
				</Table.Row>
			</Table.Head>
			<Table.Body>
				{searching ? (
					<Table.Row>
						<Table.Cell colSpan={5} centered>
							<Header loading text='Cargando datos' />
						</Table.Cell>
					</Table.Row>
				) : shown_users.length===0 ? (
					<Table.Row>
						<Table.Cell colSpan={5} centered>
							No se encontraron registros
						</Table.Cell>
					</Table.Row>
				) : (
					shown_users.map(u=>(
						<Table.Row key={u.user_id} selectable as={Link} to={`/users/${u.user_id}`}>
							<Table.Cell collapsing>{u.user_id}</Table.Cell>
							<Table.Cell>{u.first_name}</Table.Cell>
							<Table.Cell>{u.last_name}</Table.Cell>
							<Table.Cell>{u.email}</Table.Cell>
							<Table.Cell collapsing>{formatUnix(u.date_created, 'dd/MMM/yy HH:mm')}</Table.Cell>
						</Table.Row>
					))
				)}
			</Table.Body>
		</Table>
	</div>;
}

export default Users;
